import actions from './actions';
import getters from './getters';
import mutations from './mutations';

import type { AVRoomState } from './types';

const state: AVRoomState = {
  chats: [],
  polls: null,
  incomingVideoCall: null,
  activeBroadcastOnliner: null,
  broadcastOnlineCount: {},
  attendeesPrivateDiscussionRooms: [],
  jitterdelay: Math.floor(10 * Math.random()),
  channel_loading: {},
  scheduleTextQARefresh: false,
  dmchannels: null,
  isBackstageInDiscRoom: true,
  isP2PChannelBeingCreated: false,
  liteModeSwitchMessage: '',
  liveCaption: [],
  lastLiveCaption: null,
  lastLiveTranslatedCaption: null,
  lastCaption: {},
  lastTranslatedCaption: {},
  isCaptionProcessing: false,
  captionVisibilityInterval: null,
  suppressLiveCaptions: false,
  suppressLiveCaptionsInterval: null,
  chatStateInvalidated: 0,
  showSpeakerActivityMessages: true
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
